export const OUTCOME_STATUS = {
  SUBMITTED: 'Submitted',
  IN_PROGRESS: 'In Progress',
  UNSUBMITTED_CHANGE: 'Unsubmitted Changes',
  NOT_STARTED: 'Not started',
};
